import apiClient from './config';

export const configApi = {
  getContactInfo: async () => {
    try {
      const response = await apiClient.get('/config-contact');
      return response.data;
    } catch (error) {
      console.error('Error fetching contact info:', error);
      throw error;
    }
  }
}; 